import "./ContactForm.scss";
import Button from "../Button/Button";
import { useForm } from "react-hook-form";
import toast from "react-hot-toast";
import emailjs from "@emailjs/browser";

export default function ContactForm() {
  const { register, handleSubmit, reset } = useForm({
    defaultValues: {
      formName: "",
      formEmail: "",
      formMessage: "",
    },
  });

  const submitHandler = (_content: object, form: HTMLFormElement) => {
    async function sendEmail() {
      return emailjs.sendForm(
        "service_it88vif",
        "zunigaWebDev_Form",
        form,
        "dewwxOqLTEmulMfe6"
      );
    }

    toast
      .promise(
        sendEmail(),
        {
          loading: "Sending message...",
          success: "Message sent! I will reach out to you soon.",
          error: "Failed to send message.",
        },
        { duration: 4750, className: "toast" }
      )
      .then(() => {
        reset();
      })
      .catch((error) => {
        console.error("Failed to send message:", error);
      });
  };

  return (
    <div className="contactForm">
      <form
        onSubmit={handleSubmit((data, e) =>
          submitHandler(data, e?.target as HTMLFormElement)
        )}
        className="contactForm__form"
      >
        <div className="contactForm__wrapper">
          <label htmlFor="formName" className="contactForm__label">
            Name
          </label>
          <input
            {...register("formName")}
            id="formName"
            name="user_name"
            placeholder="John Smith"
            type="text"
            className="contactForm__name"
            required
          />
        </div>
        <div className="contactForm__wrapper">
          <label htmlFor="formEmail" className="contactForm__label">
            Email
          </label>
          <input
            {...register("formEmail")}
            id="formEmail"
            name="user_email"
            placeholder="your@email.com"
            type="email"
            className="contactForm__email"
            required
          />
        </div>
        <div className="contactForm__wrapper contactForm__wrapper--message">
          <label htmlFor="formMessage" className="contactForm__label">
            Message
          </label>
          <textarea
            {...register("formMessage")}
            id="formMessage"
            name="message"
            placeholder="Let's get talking about my project!"
            className="contactForm__message"
            required
          ></textarea>
        </div>
        <Button
          content="let's get started"
          classtitle="button button--secondary button__contact"
        />
      </form>
    </div>
  );
}
